module.exports = __webpack_public_path__ + "static/muss-72bdad855e8b209b9c8f13693c8fadc0.png";